import csv from 'csvtojson';

/**
 * Generate mock results for workflow steps
 * @param step - The workflow step object
 * @returns Mock results based on step type
 */
export const generateMockResults = (step: any) => {
  // Generate results based on step type
  switch (step.step_id) {
    case 'data_collection':
      // Read data from p02_makers.csv file and return as array of objects using csvtojson
      const csvData = `val,count,num_buyer,sum_amount,sum_weight,fk
DAİMLER AG,519,15,1344975.527,1690277.668,582bf4f2a8a73600820f6c78f58bdcbb
OMRON ASIA PACIFIC PTE LTD,387,4,137273.6667,18.39000016,b5509c2662a53ee386951933df5763e6
TOYOTA MOTOR ASIA PACIFIC PTE LTD,343,1,476932,0,fd796303cd2a3ad2a5ddd25085184e87
HYUNDAİ MOBİS,309,10,1659196.921,705.2280005,4aa47ae0d0bd33e8b564096f60385564
CATERPİLLAR INC,254,6,49089.25912,217867.738,d4cf0ff11be436aaad400d2944708cc1
PEPPERL FUCHS ASIA PTE. LTD,249,2,284728.9318,0,02be0615c2953179a9d95d04a0b865fb
ROBERT BOSCH GMBH,237,11,3228596.689,29437.04744,44a18ded37b03d4ebf9628543dc72863
HONEYWELL AUTOMATION INDIA LIMITED,223,15,3135285.915,0,c98893c97d06310c8193f0615b6762aa
JIANGXI JIANGLING MOTORS IMPORT AND EXPORT CO LTD,200,1,203470.8193,0,31960bc419203794952a9e5199dd1e4f
BAYERISCHE MOTOREN WERKE AG,177,4,175462.3055,5634957.181,46801ce8cfb6374283ff4ada5a4a678c
"MITSUBISHI MOTORS THAILAND CO., LTD",176,2,1035200.244,28.80099994,be862e80297638dfac78f3604926c999
LEUZE ELECTRONIC GMBH CO. KG,175,2,121692.2255,62.0999999,7c587b6f61b63efca7ce28759603a4db
SUZUKI MOTOR CORPORATION,172,10,141811.9884,163532.928,a2462562f83330bab301fb7a88ca58d3
WETHERILL ASSOCIATES INC,164,1,142327.8559,440504,a33dde68980239cea18ef111841c0c33
INTERAMERICAN MOTOR CORPORATION,161,1,4450.282029,163350,8333d0665c3639e8ad12f0b378ddf16a
SİEMENS AG,153,7,567951.8346,2171.993988,15bc264f230a3f19a18527eba7828e15
M/S. VEGA GRIESHABER KG,139,2,253316.547,0,65d1560fbd1732e8ac861ac253d52f46
OMRON CORPORATION,132,2,139969.5448,1391.800018,6e41435e39dc3f50b44d7adbecc6ce47
BOSCH AUTOMOTIVE ELECTRONICS INDIA PRIVATE LIMITED,132,9,2534799.881,0,fa4a668f17f33e1981abcd3711848605
SAIC GM WULING AUTOMOBILE CO. LTD,129,2,218758.6053,15.18299981,7c648ac03b183718a0dfd2f9acc50916
M/S. FESTO AG & CO.KG,122,1,44031.99866,0,115079ac8fd634e6a81b4c33d9233d03
SCHNEIDER ELECTRIC INDIA PVT LIMITED,120,6,816322.4455,0,4c2abc508e6433a1a790a49e0c78001f
VOLKSWAGEN AG,116,7,33625.66999,68.34999939,d7551794d6ef3456b91a41a70de7e4b7
"RECALI INTERNATIONAL, INC",115,2,8483.651966,490528.0918,43a4ed8faab43b0c9b6ffa4c8b7b7092
"NISSAN MOTOR CO.,LTD",110,4,668963.1644,261.379989,a54b3db0bbdb3f2eb73009644fd46af2
CATERPILLAR AMERICAS C.V,109,5,195989.0965,304055.12,7faa5a5a158033dba046b6ccc79a6702
`;
      const jsonArray: any[] = [];
      // Parse CSV data using csvtojson
      csv({
        checkType: true,
        colParser: {
          'count': 'number',
          'num_buyer': 'number',
          'sum_amount': 'number',
          'sum_weight': 'number'
        }
      }).fromString(csvData).then((jsonObj) => {
        jsonArray.push(...jsonObj);
      });

      return jsonArray;

    case 'data_preprocessing':
      return {
        cleaned_records: 987,
        removed_outliers: 13,
        missing_values_filled: 24,
        data_quality_score: 0.94
      };
    
    case 'sales_analysis':
      return {
        total_sales: 1234567.89,
        top_products: [
          { product: 'Widget A', sales: 45000 },
          { product: 'Widget C', sales: 38000 },
          { product: 'Widget B', sales: 32000 }
        ],
        monthly_trends: [
          { month: 'Jan', sales: 120000 },
          { month: 'Feb', sales: 135000 },
          { month: 'Mar', sales: 148000 }
        ]
      };
    
    case 'report_generation':
      return {
        report_generated: true,
        file_path: 'data/outputs/sales_report.html',
        report_size: '2.4 MB',
        charts_included: 5,
        executive_summary: 'Sales increased 15% over the quarter with Widget A leading performance.'
      };
    
    default:
      return { status: 'completed', timestamp: new Date().toISOString() };
  }
};